<template>
  <v-expansion-panel-content>
    <Navigate previous />
    <ModelInfo />
    <h6>Available Options</h6>
    <p class="sub-text-custom">Below is a list of available options for your selected vehicle type and the selected insert and trim fabrics.</p>
    <section class="opt-sec" v-for="position in positions" :key="position">
      <template v-if="isEligible(position)">
        <p><strong>{{capitalize(position)}} Seat Options</strong><br>
        Covers for armrests and adjustable headrests are sold separately. Select them when choosing options.</p>
        <v-row>
          <OptionDetails
            v-for="(option, index) in variations[position].options"
            v-bind="option"
            :key="(option.alias || option.name || 'opt') + '-' + position + '-' + index"
            :position="position"
            :index="index"
            withActions
          />
        </v-row>
      </template>
    </section>
    <Total />
    <v-row>
      <v-col class="d-flex flex-wrap justify-end">
        <v-checkbox
          v-model="agree"
          :label="`Yes, I'm finished selecting options. I understand that covers for armrests and adjustable headrests are sold separately and only included if selected on this page. (Check box to proceed.)`"
           align-self="end"
        ></v-checkbox>
      </v-col>
    </v-row>
    <Navigate previous next :valid="optReview" />
  </v-expansion-panel-content>
</template>

<style scoped lang="scss">
h5 {
  font-family: $body-font-family !important;
  font-size: 20px;
  font-weight: 700;

  @media screen and (min-width: 600px) {
    font-size: 30px;
  }
}
h6 {
  font-family: $body-font-family !important;
  font-size: 22px;
  font-weight: 700;
  margin-top: 40px;
  margin-bottom: 5px;
}
.sub-text-custom {
  padding: 10px 0 !important;
}
.top-nav {
  margin-top: 20px;
}
.opt-sec {
  margin-top: 15px;
}
</style>
<script>
  import { mapState } from 'vuex'
  import { capitalize, positions } from '@/utils'
  import ModelInfo from './ModelInfo'
  import Total from './Total'
  import Navigate from './Navigate'
  import OptionDetails from './OptionDetails'

  export default {
    data() {
      return {
        agree: false
      }
    },
    components: {
      ModelInfo,
      Total,
      Navigate,
      OptionDetails
    },
    computed: {
      positions,
      ...mapState([
        'model',
        'variations'
      ]),
      optReview() {
        return this.agree ? true : false
      }
    },
    methods: {
      capitalize,
      isEligible: function(position) {
        return this.variations[position]?.trim && this.variations[position]?.insert
      }
    }
  }
</script>
